/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelErrorEdit.title', 'defaultMessage': 'Edit error'},
    save: {id: 'channelErrorEdit.save', 'defaultMessage': 'Save comment'}
});

interface ChannelErrorEditProps {
    intl: IntlShape;
    user: User;
}

class ChannelErrorEdit extends React.Component<ChannelErrorEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'channelErrors';

    constructor() {
        super();
    }

    render() {
        let data = this.props.user.organisation.channel.channelError;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                        buttonTitle={this.props.intl.formatMessage(messages.save)}
                        columns={{'comment': {}}}
                        data={data}
                        fatQuery={Relay.QL `fragment on UpdateChannelErrorPayload {
                            updatedNode {
                                id,
                                realId,
                                channel_id,
                                organisation_id,
                                comment,
                            },
                        }`}
                        metadata={type}
                        mutation={Relay.QL `mutation { updateChannelError }`}
                        organisationId={data.organisation_id}
                        urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelErrorEdit), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.channelError;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        channelErrorId: '',
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name,
                            icon,
                        },
                        organisation_id,
                        channelError(id: $channelErrorId) {
                            createdAt,
                            type,
                            id,
                            organisation_id,
                            realId,
                            comment,
                        }
                    }
                }
            }
        `,
    },
});
